<template>
  <div>
    <OtherHeaderComponent />
    <div class="markets-container">
      <div class="header-image">
        <img src="@/public/images/markets-banner.png" alt="Markets Banner" />
      </div>

      <div class="markets-description">
        <ul class="market-list">
          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Standard bet (without bonus ball)')"></strong>
              <p v-html="getTranslatedText('Depending on the type of the Lucky Numbers game, players select number(s) they believe will be drawn. To claim winnings, the player must predict all drawn numbers. All numbers selected in one bet must be drawn.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Standard bet (incl. bonus ball)')"></strong>
              <p v-html="getTranslatedText('The player selects their numbers based on the rules of the Standard bet, but the probability of winning increases when the bonus ball hits. All numbers selected in one bet must be drawn to win.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Combination Bet')"></strong>
              <p v-html="getTranslatedText('Choose up to 14 numbers and select from 5 options ranging from single to 5-fold bets.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Select Bonus Number')"></strong>
              <p v-html="getTranslatedText('Select which number will be drawn as the bonus number.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Select the colour of the bonus ball from the options available')"></strong>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Select which number will be drawn first')"></strong>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Select whether the first number will be even or odd')"></strong>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <strong v-html="getTranslatedText('Total Value Excluding Bonus')"></strong>
              <p v-html="getTranslatedText('Select what you think the sum of all drawn numbers will be by choosing your preferred range from the options.')"></p>
            </div>
          </li>
        </ul>
      </div>

      <div style="padding: 10px; margin-bottom: 50px;">
        <HomeFooterButton />
      </div>
    </div>
  </div>
</template>


<script>
import HomeFooterButton from "@/components/common/HomeFooterButton.vue";
import OtherHeaderComponent from "@/components/common/OtherHeaderComponent.vue";
import languageMixins from "@/mixins/language-mixins";
export default {
  name: "Markets",
  mixins: [languageMixins],
  components: { HomeFooterButton, OtherHeaderComponent },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.markets-container {
  max-width: 900px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header-image img {
  width: 100%;
  margin-bottom: 20px;
}

.markets-description {
  padding: 15px;
}

.market-list {
  list-style: none;
  padding: 0;

  li {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    margin-bottom: 18px;

    .bullet {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid #0000ff;
      margin-top: 6px;
      flex-shrink: 0;
    }

    strong {
      font-weight: bold;
      display: block;
      margin-bottom: 5px;
      color: #000;
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      color: #333;
    }
  }
}

@media (max-width: 768px) {
  .markets-container {
    padding-bottom: 10px;
  }

  .header-image img {
    margin-bottom: 15px;
  }

  .market-list li p {
    font-size: 14px;
  }
}
</style>
